import React from 'react'
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles({
  //Map1
  //Connectivity Legend Colors
  colorsConnect: {
    background:
      "linear-gradient(#FFFF00, #FFC800, #FF8C00,  #FF5100, #EB0905, #D90E07,  #C71208, #B81D1D, #A3344E, #7D4585, #4A56C7, #0251D1, #0243B3, #013594, #012978, #1E2159, #291B3B, #29141F, #26100B, #26100B)",
    marginBottom: "5px",
  },
});

export default function Legend () {
  const classes = useStyles();

    return (
      <div>
        <div className="legend">
          <Grid container>
            <Grid item xs={12}>
              <p align="center">
                Connectivity
              </p>
            </Grid>
            <Grid item xs={5} className={classes.colorsConnect}>
              <div></div>
            </Grid>
            <Grid item xs={7}>
              <div>
                <div>
                  <span></span>
                  <span>High</span>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                  <span>Low</span>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
}

